import { lazyload } from '@/lib/lazy-load'

export const MarkdownEditor = lazyload(() => import('./MarkdownEditor'), {
  loading: () => (
    <div className='h-full w-full flex items-center justify-center'>
      <span className='loading spin'></span>
    </div>
  ),
})

export const MarkdownPreview = lazyload(() => import('./MarkdownPreview'), {
  loading: () => (
    <div className='w-full flex items-center justify-center'>
      <span className='loading spin'></span>
    </div>
  ),
})
